import { Component, Input, OnInit } from '@angular/core';
import { finalize } from 'rxjs';

import { ContentService } from '@app/services/content/content.service';
import { OnBoardingVideoType } from '@app/shared/interfaces/user/user-onboarding.interface';
import { BoardingVideo } from '@app/shared/models/multimedia/video.model';
import { OnBoarding } from '@app/shared/models/user/user-onboarding.model';

@Component({
  selector: 'app-on-boarding-third-step',
  templateUrl: './third-step.component.html',
  styleUrls: ['./third-step.component.scss']
})
export class ThirdStepComponent implements OnInit {
  @Input() boarding!: OnBoarding;
  videos!: BoardingVideo[];
  isLoadingVideos!: boolean;

  constructor(private contentService: ContentService) {}

  ngOnInit() {
    this.loadVideos();
  }

  private loadVideos() {
    this.isLoadingVideos = true;
    this.contentService
      .getOnBoardingContent(this.boarding.companyCode, this.boarding.type, OnBoardingVideoType.FORMATIVE)
      .pipe(finalize(() => (this.isLoadingVideos = false)))
      .subscribe((videos) => (this.videos = videos.map((video) => new BoardingVideo(video))));
  }

  trackByItems(video: BoardingVideo) {
    return video;
  }
}
